var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "articleModal",
          attrs: {
            visible: _vm.visible,
            title: "选择商品",
            top: "100px",
            width: "600px",
            "destroy-on-close": "",
            modal: false,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { ref: "pram", attrs: { "label-width": "120px", model: _vm.pram } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "商品来源：",
                    prop: "sourceType",
                    rules: [
                      {
                        required: true,
                        message: "请选择",
                        trigger: ["change"],
                      },
                    ],
                  },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      attrs: { size: "small", disabled: _vm.onlySelfSku },
                      on: { change: _vm.changeSourceType },
                      model: {
                        value: _vm.pram.sourceType,
                        callback: function ($$v) {
                          _vm.$set(_vm.pram, "sourceType", $$v)
                        },
                        expression: "pram.sourceType",
                      },
                    },
                    _vm._l(_vm.filteredGoodsTypeMap, function (item) {
                      return _c(
                        "el-radio",
                        { key: item.key, attrs: { label: item.key } },
                        [_vm._v(_vm._s(item.name))]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              !_vm.isLypSource
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "绑定方式：",
                        prop: "goodsType",
                        rules: [
                          {
                            required: true,
                            message: "请选择",
                            trigger: ["change"],
                          },
                        ],
                      },
                    },
                    [
                      _c(
                        "el-radio-group",
                        {
                          attrs: { size: "small", disabled: _vm.onlySelfSku },
                          model: {
                            value: _vm.pram.goodsType,
                            callback: function ($$v) {
                              _vm.$set(_vm.pram, "goodsType", $$v)
                            },
                            expression: "pram.goodsType",
                          },
                        },
                        [
                          _vm.isMiniProgramCustomer
                            ? [
                                _c("el-radio", { attrs: { label: 3 } }, [
                                  _vm._v("指定SKU"),
                                ]),
                              ]
                            : [
                                !_vm.onlySelfSku &&
                                [1, 2, 4, 110, 80, 81].includes(
                                  _vm.pram.sourceType
                                )
                                  ? _c("el-radio", { attrs: { label: 1 } }, [
                                      _vm._v("指定分类"),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.onlySelfSku &&
                                _vm.pram.sourceType != 18 &&
                                !_vm.isLypSource
                                  ? _c("el-radio", { attrs: { label: 2 } }, [
                                      _vm._v("指定标签"),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.isLypSource
                                  ? _c("el-radio", { attrs: { label: 3 } }, [
                                      _vm._v("指定SKU"),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.onlySelfSku &&
                                _vm.pram.sourceType != 18 &&
                                !_vm.isLypSource
                                  ? _c("el-radio", { attrs: { label: 5 } }, [
                                      _vm._v("指定SPU"),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.onlySelfSku && _vm.pram.sourceType == 3
                                  ? _c("el-radio", { attrs: { label: 4 } }, [
                                      _vm._v("指定品牌"),
                                    ])
                                  : _vm._e(),
                              ],
                        ],
                        2
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.pram.goodsType && !_vm.isLypSource
                ? _c(
                    "el-form-item",
                    { attrs: { label: "绑定内容：" } },
                    [
                      _vm.pram.goodsType == 1 &&
                      [1, 2, 4, 110].includes(_vm.pram.sourceType)
                        ? _c("el-cascader", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              options: _vm.cateIdsOption,
                              props: {
                                children: "child",
                                label: "name",
                                value: "id",
                                multiple: true,
                                leaf: 3,
                              },
                              clearable: "",
                            },
                            model: {
                              value: _vm.pram.showCateId,
                              callback: function ($$v) {
                                _vm.$set(_vm.pram, "showCateId", $$v)
                              },
                              expression: "pram.showCateId",
                            },
                          })
                        : _vm.pram.goodsType == 1 && _vm.isLypSource
                        ? _c("el-cascader", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              options: _vm.cateIdsOption,
                              props: {
                                children: "children",
                                label: "groupName",
                                value: "categoryId",
                                multiple: true,
                                checkStrictly: true,
                              },
                              clearable: "",
                            },
                            model: {
                              value: _vm.pram.showCateId,
                              callback: function ($$v) {
                                _vm.$set(_vm.pram, "showCateId", $$v)
                              },
                              expression: "pram.showCateId",
                            },
                          })
                        : _vm.pram.goodsType == 2 && _vm.pram.sourceType
                        ? _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                multiple: "",
                                clearable: "",
                                placeholder: "请选择",
                              },
                              model: {
                                value: _vm.pram.labelId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.pram, "labelId", $$v)
                                },
                                expression: "pram.labelId",
                              },
                            },
                            _vm._l(_vm.tagOption, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: {
                                  label: item.labelName,
                                  value: item.id,
                                },
                              })
                            }),
                            1
                          )
                        : _vm.pram.goodsType == 3
                        ? _c(
                            "div",
                            [
                              _c("el-input", {
                                attrs: {
                                  clearable: "",
                                  type: "textarea",
                                  rows: 4,
                                  resize: "none",
                                  placeholder: "请输入skuId",
                                },
                                model: {
                                  value: _vm.pram.skuId,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.pram, "skuId", $$v)
                                  },
                                  expression: "pram.skuId",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm.pram.goodsType == 5
                        ? _c(
                            "div",
                            [
                              _c("el-input", {
                                attrs: {
                                  clearable: "",
                                  type: "textarea",
                                  rows: 4,
                                  resize: "none",
                                  placeholder: "请输入spuId",
                                },
                                model: {
                                  value: _vm.pram.spuIds,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.pram, "spuIds", $$v)
                                  },
                                  expression: "pram.spuIds",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm.pram.goodsType == 4
                        ? _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                multiple: "",
                                clearable: "",
                                placeholder: "请选择",
                                filterable: "",
                                "filter-method": _vm.handleAgreementSearch,
                              },
                              model: {
                                value: _vm.pram.brandIds,
                                callback: function ($$v) {
                                  _vm.$set(_vm.pram, "brandIds", $$v)
                                },
                                expression: "pram.brandIds",
                              },
                            },
                            _vm._l(_vm.brandOption, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { label: item.brandStr, value: item.id },
                              })
                            }),
                            1
                          )
                        : _c("div", [_vm._v("请选择绑定方式")]),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isLypSource
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "排序方式：",
                        prop: "lypSortType",
                        rules: [
                          {
                            required: true,
                            message: "请选择排序方式",
                            trigger: ["change"],
                          },
                        ],
                      },
                    },
                    [
                      _c(
                        "el-radio-group",
                        {
                          attrs: { size: "small" },
                          model: {
                            value: _vm.pram.lypSortType,
                            callback: function ($$v) {
                              _vm.$set(_vm.pram, "lypSortType", $$v)
                            },
                            expression: "pram.lypSortType",
                          },
                        },
                        _vm._l(_vm.LYP_SORT_OPTIONS, function (o) {
                          return _c(
                            "el-radio",
                            { key: o.key, attrs: { label: o.key } },
                            [_vm._v(_vm._s(o.label))]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.isLypSource &&
              _vm.pram.sourceType !== 3 &&
              _vm.pram.goodsType !== 3
                ? _c(
                    "el-form-item",
                    { attrs: { label: "显示sku最低价：", prop: "isCheap" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          attrs: { size: "small" },
                          model: {
                            value: _vm.pram.isCheap,
                            callback: function ($$v) {
                              _vm.$set(_vm.pram, "isCheap", $$v)
                            },
                            expression: "pram.isCheap",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("是"),
                          ]),
                          _vm._v(" "),
                          _c("el-radio", { attrs: { label: 0 } }, [
                            _vm._v("否"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.saveEdit } },
                [_vm._v("保存")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "link" }, on: { click: _vm.closeEdit } },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }